<template>
    <div class="container">
        <back-button location="/initiatives"></back-button>

        <h1 class="title">Dev Day</h1>
        <div class="content">
            <div class="introduction">
                <p>
                    Dev Day is part showcase, part science show, part geek club, and part maker club. Simply put, it's a geek out for Entelectuals, giving us a chance to explore aspects of the industry that we might not get exposed to in our day job, and to showcase our technology-based interests.
                </p><br/>
                <p>
                    This year a number of Entelectuals exhibited their tech passion-projects, and fifteen delivered presentations on a variety of cutting edge topics. We hosted 4 DevDays between Johannesburg and Cape Town in 2018!
                </p><br/>
                <p class="fun-fact">
                    The purpose of DevDay is to give people an opportunity to showcase their technology-based interests.
                    <span class="author">- Sheldon Lyne</span>
                </p>
                <p>
                    After the presentations, we take the time to hang out and interact with the demo's on
                    display, enjoy the signature DevDay milkshakes and pizza, and enjoy some fun and games with our colleagues and friends.
                </p>
            </div>

            <div class="images">
                <div class="image-1 image-border"
                     :style="{ 'background-image': `url(${images.devday1})` }"></div>
                <div class="image-2 image-border inverse"
                     :style="{ 'background-image': `url(${images.devday2})` }"></div>
                <div class="image-3 image-border inverse"
                     :style="{ 'background-image': `url(${images.devday3})` }"></div>
                <div class="image-4 image-border"
                     :style="{ 'background-image': `url(${images.devday4})` }"></div>
            </div>

            <div class="stats">
                <stats-icon :icon-src="statsImages.attendees" stat="903" title="Attendees"></stats-icon>
                <stats-icon :icon-src="statsImages.speakers" stat="26" title="Speakers"></stats-icon>
                <stats-icon :icon-src="statsImages.showcases" stat="6" title="Showcases"></stats-icon>
                <stats-icon :icon-src="statsImages.talks" stat="24" title="Talks"></stats-icon>
                <stats-icon :icon-src="statsImages.events" stat="4" title="Events"></stats-icon>
            </div>
        </div>
    </div>
</template>

<script>
    import BackButton from '../../widgets/BackButton';
    import StatsIcon from '../../widgets/StatsIcon';
    // Main images imports
    import devday1 from '../../assets/images/DevDay/devday-1.jpg';
    import devday2 from '../../assets/images/DevDay/devday-2.jpg';
    import devday3 from '../../assets/images/DevDay/devday-3.jpg';
    import devday4 from '../../assets/images/DevDay/devday-4.jpg';
    // Stats images imports
    import attendeesImage from '../../assets/images/DevDay/people.png';
    import speakersImage from '../../assets/images/DevDay/student.png';
    import showcasesImage from '../../assets/images/DevDay/presentation.png';
    import talksImage from '../../assets/images/DevDay/notebook.png';
    import eventsImage from '../../assets/images/DevDay/calendar.png';

    export default {
        components: {
            BackButton,
            StatsIcon
        },
        data: function () {
            return {
                images: {
                    devday1: devday1,
                    devday2: devday2,
                    devday3: devday3,
                    devday4: devday4,
                },
                statsImages: {
                    attendees: attendeesImage,
                    speakers: speakersImage,
                    showcases: showcasesImage,
                    talks: talksImage,
                    events: eventsImage,
                }
            };

        },
        methods: {
            track () {
                this.$ga.page('/2018/initiatives/devday') // This is for Google Analytics tracking
            }
        }
    }
</script>

<style lang="scss" scoped>
    .container {
        display: grid;
        grid-template-columns: 1fr 1fr 1fr;
        grid-template-rows: auto 1fr;
        grid-template-areas: 'back title  .' 'content content content';
        color: white;
        background-size: cover;
        background-position: center;
        padding-bottom: 48px;

        @media only screen and (max-width: $screen-xs-max) {
            grid-template-columns: 1fr 2fr 1fr;
        }

        .title {
            grid-area: title;
            align-self: start;
            justify-self: center;
            margin: 24px;
            display: grid;
            align-content: center;
            justify-content: center;
        }

        .content {
            grid-area: content;
            display: grid;
            grid-template-areas: '. introduction stats .' '. images images .';
            grid-template-columns: 1fr 1fr 1fr 1fr;
            grid-gap: 32px;
            grid-template-rows: auto auto auto;

            @media only screen and (max-width: $screen-md-max) {
                grid-template-columns: 1fr 2fr 2fr 1fr;
            }

            @media only screen and (max-width: $screen-sm-max) {
                grid-template-columns: 1fr 3fr 3fr 1fr;
            }

            @media only screen and (max-width: $screen-xs-max) {
                grid-template-areas:
                        '. introduction .'
                        '. stats .'
                        '. images .';
                grid-template-columns: 32px 1fr 32px;
                grid-gap: 0;
            }

            .introduction {
                grid-area: introduction;
                text-align: justify;
                font-size: 16px;

                .fun-fact {
                    margin: 48px auto;

                    .author {
                        padding-bottom: 0;
                    }
                }

                @media only screen and (max-width: $screen-xs-max) {
                    margin-bottom: 32px;
                }
            }

            .images {
                grid-area: images;

                display: grid;
                grid-template-columns: 1fr 1fr 1fr;
                grid-template-rows: 200px 200px;
                grid-template-areas: 'image-1 image-2 image-4' 'image-1 image-3 image-4';

                grid-gap: 24px;
                grid-auto-flow: column;

                @media only screen and (max-width: $screen-md-max) {
                    grid-template-columns: 1fr 1fr;
                    grid-template-rows: 200px 200px 200px;
                    grid-template-areas: 'image-2 image-2'
                                         'image-1 image-4'
                                         'image-3 image-3';
                }

                @media only screen and (max-width: $screen-xs-max) {
                    grid-template-columns: 1fr;
                    grid-template-rows: 200px 200px 200px 200px;
                    grid-template-areas: 'image-1'
                                         'image-2'
                                         'image-3'
                                         'image-4';
                }

                [class^='image-'],
                [class*=' image-'] {

                    background: no-repeat center;
                    background-size: cover;

                    height: 100%;
                }

                .image-1 {
                    grid-area: image-1;
                }

                .image-2 {
                    grid-area: image-2;
                }

                .image-3 {
                    grid-area: image-3;
                }

                .image-4 {
                    grid-area: image-4;
                }
            }

            .stats {
                grid-area: stats;
                display: grid;
                grid-template-columns: 1fr 1fr 1fr;
                grid-gap: 16px;

                @media only screen and (max-width: $screen-md-max) {
                    grid-template-columns: 1fr 1fr;
                }

                @media only screen and (max-width: $screen-xs-max) {
                    margin-bottom: 32px;
                }
            }

            .fun-fact {
                width: 75%;
                margin: 8px auto 0;

                .author {
                    display: block;
                    padding: 12px 0;
                    color: #FFF;
                }
            }
        }
    }
</style>
